var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.label)?_c('div',{staticClass:"code-label typo-body-1"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }